export default __webpack_public_path__ + "51f87df640007bff3fea1d1ccf3e9498.svg";